<template>
  <div>
    <div class="modal-backdrop" @click="close"></div>
    <div class="modal">
      <header class="modal-header">
        <div class="header">{{ header }}</div>
      </header>
      <section class="modal-body">
        <slot name="body">{{ body }}</slot>
      </section>
      <footer class="modal-footer">
        <slot />
      </footer>
    </div>
  </div>
</template>

<style>
@import "./style.css";
</style>

<script>
export default {
  name: "BgModal",
  props: {
    header: String,
    body: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
